import { graphql } from 'react-relay';

/**
 * Slice-7 cross-tenant vault search — matches on name, identifier or owner email.
 * An empty `query` returns every vault, so the list renders unfiltered on first
 * load and narrows as the operator types. Read-only.
 *
 * `filter: COMPLIMENTARY` with a blank query selects the vaults in billing rather than
 * by name, so it is every live comp — not capped like the unfiltered directory — and
 * adds up to the summary's complimentary count. `grantedBy` is operator-only.
 */
export const vaultSearchQuery = graphql`
    query vaultSearchQuery($query: String!, $filter: VaultListFilter!) {
        vaultSearch(query: $query, filter: $filter) {
            vaultId
            name
            identifier
            jurisdiction
            ownerEmail
            planName
            subscriptionStatus
            isComplimentary
            complimentaryUntil
            grantedBy
        }
    }
`;
